import React, { useState, useEffect, useRef } from "react";
import { statsData } from "../data/mock";

const AnimatedCounter = ({ value, label }) => {
  const [display, setDisplay] = useState(value);
  const ref = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          // Extract numeric part
          const numericMatch = value.match(/\d+/);
          if (numericMatch) {
            const target = parseInt(numericMatch[0]);
            const prefix = value.slice(0, value.indexOf(numericMatch[0]));
            const suffix = value.slice(
              value.indexOf(numericMatch[0]) + numericMatch[0].length
            );
            let current = 0;
            const increment = Math.ceil(target / 40);
            const timer = setInterval(() => {
              current += increment;
              if (current >= target) {
                current = target;
                clearInterval(timer);
              }
              setDisplay(`${prefix}${current}${suffix}`);
            }, 30);
            return () => clearInterval(timer);
          }
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value, hasAnimated]);

  return (
    <div ref={ref} className="text-center">
      <div className="text-4xl md:text-5xl font-bold text-white mb-2">
        {display}
      </div>
      <div className="text-emerald-200/70 text-sm font-medium uppercase tracking-wider">
        {label}
      </div>
    </div>
  );
};

export const StatsSection = () => {
  return (
    <section className="py-20 bg-emerald-800 relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-emerald-400 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-teal-400 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          {statsData.map((stat, i) => (
            <AnimatedCounter key={i} value={stat.value} label={stat.label} />
          ))}
        </div>
      </div>
    </section>
  );
};
